module.exports = __webpack_public_path__ + "static/media/2004_GDP_totalRate.5d96a0ac.png";